import type { LinkViewModel } from '@/types/layout/link-view-model';
import type { StructuredText } from '@/types/prismic/common';

export const firstStructuredText = (field?: StructuredText[]): string | undefined => field?.[0]?.text;

export const imageUrl = (image?: { url?: string | null } | null): string | undefined => image?.url ?? undefined;

export const toLinkViewModel = (link?: { url?: string; target?: string } | null): LinkViewModel => ({
    url: link?.url ?? '',
    target: link?.target
});

export const splitLegalText = (legal?: string | null): string[] => legal?.split('\\n ') ?? [];

export const mapGamblingProblemTexts = (paragraphs?: StructuredText[]): string[] =>
    paragraphs?.map((paragraph) => paragraph.text).filter(Boolean) ?? [];
